module.exports = __webpack_public_path__ + "img/img05.95c61263.svg";